var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleFuture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.6667 33.6667V30.3334H40.8333C39.5925 30.3334 38.972 30.3334 38.47 30.1702C37.4552 29.8406 36.6595 29.0449 36.3298 28.0301C36.1667 27.528 36.1667 26.9076 36.1667 25.6667C36.1667 23.8055 36.1667 22.8748 35.922 22.1217C35.4273 20.5995 34.234 19.406 32.7118 18.9115C31.9587 18.6667 31.028 18.6667 29.1667 18.6667H15.3333L15.3793 37.0001C15.4704 38.8279 15.7423 39.9682 16.5537 40.7797C17.3652 41.5911 18.5055 41.8631 20.3333 41.9541C20.3579 40.1344 21.8411 38.6667 23.6667 38.6667C25.5076 38.6667 27 40.1591 27 42.0001H37C37 40.1591 38.4923 38.6667 40.3333 38.6667C42.159 38.6667 43.6418 40.1344 43.6663 41.9542C45.4942 41.8631 46.6348 41.5911 47.4463 40.7797C48.6667 39.5592 48.6667 37.5951 48.6667 33.6667Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 41.9541C18.5055 41.8631 17.3652 41.5911 16.5537 40.7797C15.7423 39.9682 15.4704 38.8279 15.3793 37.0001M27 42.0001H37M43.6667 41.9541C45.4945 41.8631 46.6348 41.5911 47.4463 40.7797C48.6667 39.5592 48.6667 37.5951 48.6667 33.6667V30.3334H40.8333C39.5925 30.3334 38.972 30.3334 38.47 30.1702C37.4552 29.8406 36.6595 29.0449 36.3298 28.0301C36.1667 27.528 36.1667 26.9076 36.1667 25.6667C36.1667 23.8055 36.1667 22.8748 35.922 22.1217C35.4273 20.5995 34.234 19.406 32.7118 18.9115C31.9587 18.6667 31.028 18.6667 29.1667 18.6667H15.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 45.3334C42.1743 45.3334 43.6667 43.841 43.6667 42.0001C43.6667 40.1591 42.1743 38.6667 40.3333 38.6667C38.4924 38.6667 37 40.1591 37 42.0001C37 43.841 38.4924 45.3334 40.3333 45.3334Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 45.3334C25.5076 45.3334 27 43.841 27 42.0001C27 40.1591 25.5076 38.6667 23.6667 38.6667C21.8257 38.6667 20.3333 40.1591 20.3333 42.0001C20.3333 43.841 21.8257 45.3334 23.6667 45.3334Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 25.3333H25.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 30.3333H22",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 22H39.202C41.6277 22 42.8403 22 43.8273 22.5895C44.8143 23.179 45.3893 24.2469 46.5393 26.3825L48.6667 30.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleFuture);
export default __webpack_public_path__ + "static/media/vehicle-future.d1fb8d7d84be888ad02a66ee1d9df448.svg";
export { ForwardRef as ReactComponent };